var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ds-control mobile ds_teas_batch_occupation_form" },
    [
      _c(
        "div",
        { staticClass: "form_top" },
        [
          _c("div", { staticClass: "top_place" }, [
            _vm._m(0),
            _c(
              "div",
              {
                staticClass: "place_value",
                on: {
                  click: function ($event) {
                    _vm.showSelectField = true
                  },
                },
              },
              [
                _vm.place
                  ? _c("p", [_vm._v(_vm._s(_vm.place))])
                  : _c("span", [_vm._v("请选择")]),
                _c("i", { staticClass: "iconfont icon-icon_more" }),
              ]
            ),
          ]),
          _c("DsfMobileTextbox", {
            attrs: {
              label: "占用事由",
              fromDirection: "vertical",
              inputAlign: "left",
              required: true,
            },
            model: {
              value: _vm.reason,
              callback: function ($$v) {
                _vm.reason = $$v
              },
              expression: "reason",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "form_content" },
        [
          _c("DsfMobileDateIntervalPicker", {
            attrs: {
              labelS: "占用日期",
              fromDirection: "vertical",
              inputAlign: "left",
              required: true,
            },
            on: { change: _vm.dateChange },
            model: {
              value: _vm.date,
              callback: function ($$v) {
                _vm.date = $$v
              },
              expression: "date",
            },
          }),
          _c("DsfMobileTextbox", {
            attrs: {
              label: "联系人",
              fromDirection: "vertical",
              inputAlign: "left",
            },
            model: {
              value: _vm.contact_text,
              callback: function ($$v) {
                _vm.contact_text = $$v
              },
              expression: "contact_text",
            },
          }),
          _c("DsfMobileTextbox", {
            attrs: {
              label: "联系电话",
              fromDirection: "vertical",
              inputAlign: "left",
            },
            model: {
              value: _vm.phone,
              callback: function ($$v) {
                _vm.phone = $$v
              },
              expression: "phone",
            },
          }),
          _c("div", { staticClass: "content_checkbox" }, [
            _vm._m(1),
            _c(
              "div",
              { staticClass: "checkbox_item" },
              _vm._l(_vm.weekArr, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    class: [
                      item.check ? "choose_check" : "",
                      item.readOnly ? "read_only" : "",
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.chooseWeek(item, index)
                      },
                    },
                  },
                  [_vm._v(_vm._s(item.text))]
                )
              }),
              0
            ),
          ]),
          _c(
            "div",
            { staticClass: "content_time" },
            [
              _c("p", [_vm._v("占用时间段")]),
              _vm._l(_vm.timeArr, function (item, index) {
                return _c("div", { key: index, staticClass: "time_box" }, [
                  _c(
                    "div",
                    {
                      staticClass: "time_s",
                      on: {
                        click: function ($event) {
                          return _vm.selectTime("start", index)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.stime))]
                  ),
                  _c("span", [_vm._v("-")]),
                  _c(
                    "div",
                    {
                      staticClass: "time_e",
                      on: {
                        click: function ($event) {
                          return _vm.selectTime("end", index)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.etime))]
                  ),
                  _c("i", {
                    staticClass: "iconfont icon-delete",
                    on: {
                      click: function ($event) {
                        return _vm.deleteTime(item, index)
                      },
                    },
                  }),
                ])
              }),
              _c(
                "div",
                { staticClass: "add_time", on: { click: _vm.addTime } },
                [
                  _c("i", { staticClass: "iconfont icon-hao" }),
                  _c("span", [_vm._v("新增时间段")]),
                ]
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c("div", { staticClass: "btn_zw" }),
      _c("div", { staticClass: "btn" }, [
        _c(
          "div",
          {
            staticClass: "btn_fh",
            on: {
              click: function ($event) {
                return _vm.$router.go(-1)
              },
            },
          },
          [_vm._v("返回")]
        ),
        _c("div", { staticClass: "btn_qd", on: { click: _vm.sumbit } }, [
          _vm._v("确定"),
        ]),
      ]),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showTime,
            callback: function ($$v) {
              _vm.showTime = $$v
            },
            expression: "showTime",
          },
        },
        [
          _c("van-datetime-picker", {
            attrs: { type: "time", title: "选择时间" },
            on: {
              cancel: function ($event) {
                _vm.showTime = false
              },
              confirm: _vm.confirmTime,
            },
            model: {
              value: _vm.currentTime,
              callback: function ($$v) {
                _vm.currentTime = $$v
              },
              expression: "currentTime",
            },
          }),
        ],
        1
      ),
      _c("dsf-mobile-select-field", {
        attrs: {
          "select-all": false,
          show: _vm.showSelectField,
          isCheckbox: true,
        },
        on: {
          close: function ($event) {
            _vm.showSelectField = false
          },
          "choose-data": _vm.chooseData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "place_label" }, [
      _c("span", [_vm._v("*")]),
      _vm._v("占用地点 "),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("span", [_vm._v("*")]), _vm._v("重复设置")])
  },
]
render._withStripped = true

export { render, staticRenderFns }